module.exports = __webpack_public_path__ + "static/media/asset-cover.daf86af1.jpg";